// Iter 19 — defensive narrower for JobSnapshot.citations_jsonb. The backend
// Pydantic types it as ``unknown[]`` (per services/rag-api/app/routes/
// query_jobs.py JobSnapshot.citations_jsonb) so a single malformed legacy row
// could crash MessageRenderer (which assumes every cite has chunk_id +
// doc_id + index + preview). Filter to the subset that satisfies the
// minimal PersistedCitationRef contract — same set of required fields MessageRenderer
// reads, so any cite that passes here is safe to render.
//
// Mirror of services/chat-ui/src/components/history/JobDetailDrawer.tsx::
// narrowCitation (Phase 5b polish item (b) commit a8abd6f7) — kept as a
// separate exported helper so chatStore.loadJobFromHistory (iter 19) + the
// existing drawer share ONE definition. Future maintainers refactoring this
// MUST keep both consumers in sync; the JobDetailDrawer site carries a
// cross-reference comment pointing here.
//
// ADR-096 Phase 3 — delegates to normalizeCitations to accept BOTH legacy
// ADR-082 shape (index field) AND new ADR-096 shape (marker_index field).
// The thin `preview` post-filter preserves the iter 19 defensive contract
// (well-formed PersistedCitationRefs always have preview; malformed snapshot rows
// silently drop) so existing render paths see no regression. Phase 6 will
// retire narrowCitations entirely + migrate callers directly to
// normalizeCitations (see ADR-096 §11 Phase 6 deletion design).
import { normalizeCitations } from "@/runtime/citationDiscriminator";
import type { PersistedCitationRef } from "@/types";

export function narrowCitations(raw: unknown): PersistedCitationRef[] {
  // ADR-096 Phase 3: route through normalizeCitations to accept BOTH cohorts.
  // The post-filter on `preview` preserves the iter 19 minimal-render-contract
  // guard (MessageRenderer + InlineFootnotes both read preview).
  return normalizeCitations(raw).filter(
    (c) => typeof (c as { preview?: unknown }).preview === "string",
  );
}
